import { post } from '../../../util/api'
import * as type from './type'
import * as selector from './selector'
import * as salesOrderSelector from '../../sales-order/state/detail/selector'
import * as customerSelector from '../../customer/state/detail/selector'
import * as taskName from '../../process/ui-definition/sales-order/in-shop-scan/task-name'

export const changeRefinementReason = (name, value) => {
    return ({
        type: type.CHANGE_REFINEMENT_REASON,
        payload: {
            refinementReason: value,
        },
    })
}

export const getRefinementReasonRequest = () => ({
    type: type.GET_REFINEMENT_REASON_REQUEST,
})

export const getRefinementReasonSuccess = (refinementReason) => ({
    type: type.SAVE_REFINEMENT_REASON_SUCCESS,
    payload: {
        refinementReason,
    },
})

export const getRefinementReasonError = (error) => ({
    type: type.GET_REFINEMENT_REASON_ERROR,
    payload: {
        error,
    },
})

export const getRefinementReason = (task) => (dispatch, getState) => {
    dispatch(getRefinementReasonRequest())
    const state = getState()
    const salesOrder = salesOrderSelector.selectSalesOrder(state)
    const customerId = customerSelector.selectCustomerId(state)

    let url = ''
    let body = {}
    if (task === taskName.SELECT_REFINEMENT_TYPE) {
        url = '/api/refinement/get-reason-by-sales-order-id'
        body = { salesOrderId: salesOrder.id }
    }
    else {
        url = '/api/refinement/get-reason-by-customer-id'
        body = { customerId: customerId }
    }

    post(url, body)
    .then(({refinementReason}) => {
        dispatch(getRefinementReasonSuccess(refinementReason))
    })
    .catch(error => {
        dispatch(getRefinementReasonError(error))
    })
}

export const saveRefinementReasonRequest = () => ({
    type: type.SAVE_REFINEMENT_REASON_REQUEST,
})

export const saveRefinementReasonSuccess = (refinementReason) => ({
    type: type.SAVE_REFINEMENT_REASON_SUCCESS,
    payload: {
        refinementReason,
    },
})

export const saveRefinementReasonError = (error) => ({
    type: type.SAVE_REFINEMENT_REASON_ERROR,
    payload: {
        error,
    },
})

export const saveRefinementReason = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }
    const salesOrder = salesOrderSelector.selectSalesOrder(state)
    const customerId = customerSelector.selectCustomerId(state)
    const refinementReason = selector.selectRefinementReason(state)
    dispatch(saveRefinementReasonRequest())
    post('/api/refinement/save',{
        customerId,
        refinementReason,
        salesOrderId: salesOrder.id
        })
        .then(refinementReason => {
            dispatch(saveRefinementReasonSuccess(refinementReason))
        })
        .catch(error => {
            dispatch(saveRefinementReasonError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/refinement/state/action.js